import React from 'react';

import { Root, Path } from './index.styled';

const TargetIcon = () => {
  return (
    <Root>
      <svg viewBox="0 0 1000 1000">
        <g>
          <Path d="M 1000,500 A 500,500 0 0 1 500,1000 500,500 0 0 1 0,500 500,500 0 0 1 500,0 500,500 0 0 1 1000,500" />
        </g>
      </svg>
    </Root>
  );
};

export default TargetIcon;
